export const common = {
  // Header
  "header.solutions": "Solutions",
  "header.about": "About", 
  "header.testimonials": "Testimonials",
  "header.contact": "Contact",
  "header.getStarted": "Get Started",
  
  // Hero Section
  "hero.slide1.title": "Streamline Operations with Smart AI",
  "hero.slide1.subtitle": "Optimize your industrial processes with cutting-edge AI agents, enhancing efficiency and productivity across the United States.",
  "hero.slide2.title": "AI-Powered Industrial Excellence", 
  "hero.slide2.subtitle": "Transform your manufacturing processes with intelligent automation and predictive analytics.",
  "hero.slide3.title": "Intelligent Digital Solutions",
  "hero.slide3.subtitle": "Harness the power of agentic AI for advanced automation systems and smart industrial operations.",
  "hero.optimizeWithAI": "Optimize with AI",
  "hero.learnMore": "Learn More",
  
  // About Section
  "about.title": "Empowering Industries with AI Innovation",
  "about.paragraph1": "At AiCH, we are at the forefront of transforming industrial landscapes through advanced AI agents. Based in the United States, our mission is to enhance operational efficiency and innovation across various sectors.",
  "about.paragraph2": "Our cutting-edge solutions integrate seamlessly with existing systems, driving growth and sustainability. Join us as we shape the future of industry with intelligence and ingenuity.",
  
  // Values Section
  "values.badge": "Enhancing Industry",
  "values.title": "Innovating AI for Industrial Growth",
  "values.subtitle": "Empowering industries with cutting-edge AI solutions that drive progress, enhance efficiency, and foster sustainable growth across the United States.",
  "values.innovation.title": "Innovation",
  "values.innovation.description": "At AiCH, we are committed to pushing the boundaries of technology. Our team continually explores new frontiers in AI to deliver cutting-edge solutions that empower industries.",
  "values.integrity.title": "Integrity",
  "values.integrity.description": "We believe in conducting our business with the highest level of honesty and transparency. Our clients trust us to provide reliable and ethical AI solutions that drive success.",
  "values.collaboration.title": "Collaboration",
  "values.collaboration.description": "Teamwork is at the heart of everything we do. We foster a collaborative environment where diverse ideas thrive, leading to creative solutions and shared success.",
  "values.excellence.title": "Excellence",
  "values.excellence.description": "Our pursuit of excellence drives us to deliver superior products and services. We are dedicated to achieving the highest standards in everything we do, ensuring quality and value for our clients.",
  "values.sustainability.title": "Sustainability",
  "values.sustainability.description": "AiCH is committed to sustainable practices that benefit both our clients and the planet. We strive to create AI solutions that are not only effective but also environmentally responsible.",
  
  // Solutions Section
  "solutions.badge": "Efficiency Unleashed",
  "solutions.title": "Optimize Efficiency Using Advanced AI",
  "solutions.subtitle": "Enhance productivity with cutting-edge AI solutions tailored for industrial applications, driving unprecedented growth and operational excellence.",
  "solutions.predictiveMaintenance.title": "Predictive Maintenance",
  "solutions.predictiveMaintenance.description": "Utilize AI to anticipate equipment failures and reduce downtime.",
  "solutions.processOptimization.title": "Process Optimization",
  "solutions.processOptimization.description": "Enhance operational efficiency through AI-driven insights.",
  "solutions.qualityControl.title": "Quality Control Automation", 
  "solutions.qualityControl.description": "Implement AI to ensure consistent product quality and reduce defects.",
  "solutions.supplyChain.title": "Supply Chain Efficiency",
  "solutions.supplyChain.description": "Optimize logistics and inventory management with AI analytics.",
  "solutions.energyManagement.title": "Energy Management",
  "solutions.energyManagement.description": "Reduce energy consumption using AI to monitor and adjust usage.",
  "solutions.safetyMonitoring.title": "Safety Monitoring",
  "solutions.safetyMonitoring.description": "Enhance workplace safety with AI-powered surveillance and alerts.",
  
  // Testimonials Section
  "testimonials.badge": "Proven Impact",
  "testimonials.title": "Hear From Our Partners", 
  "testimonials.subtitle": "AiCH's innovative AI solutions have transformed our operations, boosting efficiency and driving unprecedented growth. Highly recommended!",
  "testimonials.jordan.content": "AiCH revolutionized our operations with its cutting-edge AI solutions. Efficiency and productivity skyrocketed, allowing us to focus on strategic growth.",
  "testimonials.alex.content": "AiCH's AI agents transformed our workflow efficiency and innovation. Their expertise in industrial AI is unmatched, offering us strategic insights and sustainable growth.",
  "testimonials.taylor.content": "Partnering with AiCH has been transformative for us. Their AI-driven solutions streamlined our processes, boosting both efficiency and innovation. It's a game-changer for any industry.",
  
  // CTA Section
  "cta.title": "Transform Your Industry Today",
  "cta.subtitle": "Unlock unprecedented efficiency and innovation with AiCH's advanced AI solutions tailored for industrial leaders. Elevate your operations and stay ahead in the competitive market.",
  "cta.exploreSolutions": "Explore Solutions",
  "cta.scheduleDemo": "Schedule Demo",
  
  // Language Switcher
  "language.select": "Language"
};

export default {
  ...common,
  cta: {
    title: 'Ready to Transform Your Industry?',
    subtitle: 'Join leading companies leveraging AI to drive innovation and efficiency. Let\'s discuss how our solutions can benefit your business.',
    exploreSolutions: 'Explore Solutions',
    scheduleDemo: 'Schedule Demo'
  },
  demo: {
    title: 'Schedule a Demo',
    subtitle: 'Fill out the form below and our team will contact you shortly to arrange a personalized demonstration.',
    name: 'Full Name',
    namePlaceholder: 'Enter your full name',
    email: 'Email Address',
    emailPlaceholder: 'Enter your email',
    company: 'Company Name',
    companyPlaceholder: 'Enter your company name',
    phone: 'Phone Number',
    phonePlaceholder: 'Enter your phone number',
    message: 'Additional Information',
    messagePlaceholder: 'Tell us about your needs and interests...',
    submit: 'Submit Request',
    submitting: 'Submitting...',
    cancel: 'Cancel',
    successMessage: 'Thank you! Your demo request has been submitted successfully. We will contact you soon.',
    errorMessage: 'Sorry, there was an error submitting your request. Please try again.'
  }
};
